import { Box, Card } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { connect } from "react-redux";
import { selectComments } from "../../redux/selectors/firebase";
import CommentContainer, { Comments, ICommentContainer, IScriptComment } from "./CommentContainer";

const width = 60;
const useStyles = makeStyles((theme) => ({
    highlighted: {
        marginLeft: parseInt(theme.spacing(8)) - width
    },
    default: {
        marginLeft: theme.spacing(3),
    },
    raised: {
        marginLeft: theme.spacing(1)
    },
}));


interface IProps
{
    comments: Comments
    commentHighlight?: string
    onHighlightComment: (commentID?: string) => void
    state: string
    stateHighlight?: string
}

function filterCommentsByState(state: string)
{
    return ([id, commentContainer]: [string, ICommentContainer]) =>
    {
        return commentContainer.type.name === "script"
            && commentContainer.type.state === state
            && !commentContainer.deleted
            && !commentContainer.resolved;
    }
}

function StateComments({ comments, commentHighlight, onHighlightComment, state, stateHighlight }: IProps)
{
    const classes = useStyles();
    return (
        <Box>
            {comments && Object.entries(comments).filter(
                filterCommentsByState(state)
            ).sort(([, aComment], [, bComment]) =>
            {
                return (aComment.type as IScriptComment).state.localeCompare((bComment.type as IScriptComment).state);
            }
            ).map(([id, commentContainer]) =>
            {
                return (
                    <CommentContainer repliesCollapsible={true} component={Card} stateClasses={classes}
                        key={id} commentId={id} details={commentContainer} highlighted={commentHighlight === id}
                        onHighlightComment={onHighlightComment} raised={stateHighlight === state} />
                );
            })}
        </Box>
    );
}

const mapStateToProps = (store: never) => ({
    comments: selectComments(store)
});

export default connect(mapStateToProps, {
})(StateComments);